import React, { useState, useEffect } from "react";
import { Image, Button } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { JumpApply } from "../../../components/Jump";
import "./index.scss";
function Banner() {
  const history = useHistory();
  const { t } = useTranslation();
  const aboutUsBannerContent = t("aboutUs.space_part1", {
    returnObjects: true,
  });
  const clickTo = () => {
    history.push(`/apply`);
  };
  return (
    <div className="aboutUs_banner_side">
      <div className="aboutUs_banner_con">
        <div className="aboutUs_banner_conBox">
          <div className="banner_til">{aboutUsBannerContent.title}</div>
          <div className="banner_dat">{aboutUsBannerContent.detail}</div>
          <div className="banner_btn_box">
            <Button className="banner_btn" onClick={() => clickTo()}>
              {aboutUsBannerContent.btnText}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
